import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { HttpClientInterceptor } from "@interceptors/httpInterceptor";
import { AccidentService } from "@services/accident.service";
import { AllocationService } from "@services/allocation.service";
import { AllocationWorkOrderService } from "@services/allocationWorkOrder.service";
import { AppSettingsService } from "@services/appSettings.service";
import { AssetService } from "@services/asset.service";
import { AssetEventService } from "@services/assetEvent.service";
import { AssetTypeService } from "@services/assetType.service";
import { AuditService } from "@services/audit.service";
import { AuthService } from "@services/auth.service";
import { AzureBlobStorageService } from "@services/azureBlobStorage.service";
import { BankDetailsService } from "@services/bankDetails.service";
import { BannerService } from "@services/banner.service";
import { ClientService } from "@services/client.service";
import { ClientContactService } from "@services/clientContact.service";
import { ClientDocumentService } from "@services/clientDocument.service";
import { ClientInteractionService } from "@services/clientInteraction.service";
import { ClientLocationService } from "@services/clientLocation.service";
import { CompanyHolidayService } from "@services/companyHoliday.service";
import { ContractService } from "@services/contract.service";
import { ContractPaymentService } from "@services/contractPayment.service";
import { CriticalSpareService } from "@services/criticalSpare.service";
import { CrmContactService } from "@services/crmContact.service";
import { CrmEventService } from "@services/crmEvent.service";
import { CrmEventAttendeeService } from "@services/crmEventAttendee.service";
import { CrmInteractionService } from "@services/crmInteraction.service";
import { CrmLeadService } from "@services/crmLead.service";
import { CrmOpportunityService } from "@services/crmOpportunity.service";
import { CrmTaskService } from "@services/crmTask.service";
import { CuttingToolService } from "@services/cuttingTool.service";
import { DashboardService } from "@services/dashboard.service";
import { DeliveryNoteService } from "@services/deliveryNote.service";
import { EdiForecastService } from "@services/ediForecast.service";
import { EdiMessageService } from "@services/ediMessage.service";
import { EdiOrderService } from "@services/ediOrder.service";
import { EdiShippingNoteService } from "@services/ediShippingNote.service";
import { EdiShippingNoteItemService } from "@services/ediShippingNoteItem.service";
import { EmailService } from "@services/email.service";
import { EmailTemplateService } from "@services/emailTemplate.service";
import { ExportLogService } from "@services/exportLog.service";
import { ExternalPackagingService } from "@services/externalPackaging.service";
import { ExternalPackagingStockMovementHistoryService } from "@services/externalPackagingStockMovementHistory.service";
import { FeatureService } from "@services/feature.service";
import { FileService } from "@services/file.service";
import { FirewallLogService } from "@services/firewallLog.service";
import { FirewallLogFailureReasonService } from "@services/firewallLogFailureReason.service";
import { GroupService } from "@services/group.service";
import { HelpDocumentService } from "@services/helpDocument.service";
import { HolidayAllowanceService } from "@services/holidayAllowance.service";
import { HolidayRequestService } from "@services/holidayRequest.service";
import { HolidaySettingsService } from "@services/holidaySettings.service";
import { InterfaceDeviceService } from "@services/interfaceDevice.service";
import { InvoiceService } from "@services/invoice.service";
import { LinkedPartGroupService } from "@services/linkedPartGroup.service";
import { LoadingService } from "@services/loading.service";
import { LogService } from "@services/logs.service";
import { MachineService } from "@services/machine.service";
import { MachineAvailabilityService } from "@services/machineAvailability.service";
import { MachineEventService } from "@services/machineEvent.service";
import { MachineQuestionnaireService } from "@services/machineQuestionnaire.service";
import { MachineRequestService } from "@services/machineRequest.service";
import { MaintenanceScheduleService } from "@services/maintenanceSchedule.service";
import { MaterialService } from "@services/material.service";
import { MenuService } from "@services/menu.service";
import { MenuItemService } from "@services/menuItem.service";
import { ModalService } from "@services/modal.service";
import { NonConformanceReportService } from "@services/nonConformanceReport.service";
import { OperationService } from "@services/operation.service";
import { OpsActionAuditService } from "@services/opsActionAudit.service";
import { OutsideProcessContractService } from "@services/outsideProcessContract.service";
import { OutsideProcessContractContingencySupplierService } from "@services/outsideProcessContractContingencySupplier.service";
import { OutsideProcessContractMovementService } from "@services/outsideProcessContractMovement.service";
import { OutsideProcessTypeService } from "@services/outsideProcessType.service";
import { OutsourcedSpecificationService } from "@services/outsourcedSpecification.service";
import { PackagingService } from "@services/packaging.service";
import { PackagingStockMovementHistoryService } from "@services/packagingStockMovementHistory.service";
import { PartService } from "@services/part.service";
import { PartRelationshipService } from "@services/partRelationship.service";
import { PaymentTermService } from "@services/paymentTerm.service";
import { PFMEAService } from "@services/pfmea.service";
import { ProcessService } from "@services/process.service";
import { ProcessMachineService } from "@services/processMachine.service";
import { ProductionRequestService } from "@services/productionRequest.service";
import { ProductionToolService } from "@services/productionTool.service";
import { ProductionToolBomItemService } from "@services/productionToolBomItem.service";
import { ProductionToolEventService } from "@services/productionToolEvent.service";
import { ProductionToolPartService } from "@services/productionToolPart.service";
import { ProductionToolProgramService } from "@services/productionToolProgram.service";
import { ProductionToolProgramLineService } from "@services/productionToolProgramLine.service";
import { ProjectService } from "@services/project.service";
import { PromiseService } from "@services/promise.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { PurchasableItemService } from "@services/purchasableItem.service";
import { PurchaseLogService } from "@services/purchaseLog.service";
import { PurchaseLogLineItemAllocationService } from "@services/purchaseLogLineItemAllocation.service";
import { PurchaseLogWorkOrderService } from "@services/purchaseLogWorkOrder.service";
import { QmsDocumentService } from "@services/qmsDocument.service";
import { QmsDocumentVersionService } from "@services/qmsDocumentVersion.service";
import { QuarantinedPartService } from "@services/quarantinedPart.service";
import { QuotationAnalysisFormService } from "@services/quotationAnalysisForm.service";
import { ReportService } from "@services/report.service";
import { RequestForQuoteService } from "@services/requestForQuote.service";
import { SalesEnquiryService } from "@services/salesEnquiry.service";
import { SalesOrderService } from "@services/salesOrder.service";
import { SalesOrderPartService } from "@services/salesOrderPart.service";
import { ScheduledReportService } from "@services/scheduledReport.service";
import { SiteService } from "@services/site.service";
import { SkillService } from "@services/skillService.service";
import { SmsService } from "@services/sms.service";
import { SmsTemplateService } from "@services/smsTemplate.service";
import { StaffAttendanceService } from "@services/staffAttendance.service";
import { StockStoreService } from "@services/stockStore.service";
import { StockStoreHistoryService } from "@services/stockStoreHistory.service";
import { StockStoreWorkOrderAllocationService } from "@services/stockStoreWorkOrderAllocation.service";
import { SupervisorRequestService } from "@services/supervisorRequest.service";
import { SupervisorRequestReasonService } from "@services/supervisorRequestReason.service";
import { SupplierService } from "@services/supplier.service";
import { SupplierContactService } from "@services/supplierContact.service";
import { SupplierDocumentService } from "@services/supplierDocument.service";
import { SupplierLocationService } from "@services/supplierLocation.service";
import { SupplierPurchaseTypeService } from "@services/supplierPurchaseType.service";
import { SupplierQuestionnaireService } from "@services/supplierQuestionnaire.service";
import { SystemParameterService } from "@services/systemParameter.service";
import { ToolHolderService } from "@services/toolHolder.service";
import { ToolHolderMachineService } from "@services/toolHolderMachine.service";
import { ToolingTypeService } from "@services/toolingType.service";
import { ToolOrderService } from "@services/toolOrder.service";
import { ToolroomProcessService } from "@services/toolroomProcess.service";
import { ToolroomProcessMachineService } from "@services/toolroomProcessMachine.service";
import { TrainingService } from "@services/trainingService.service";
import { UserService } from "@services/user.service";
import { UserLoginCountryBypassService } from "@services/userLoginCountryBypass.service";
import { UserProfileService } from "@services/userProfile.service";
import { VisitService } from "@services/visit.service";
import { VisitorService } from "@services/visitor.service";
import { WorkloadLogService } from "@services/workloadLog.service";
import { WorkOrderService } from "@services/workOrder.service";
import { WorkOrderStageService } from "@services/workOrderStage.service";
import { WorkOrderStageInspectionService } from "@services/workOrderStageInspection.service";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { EmailEditorModule } from "angular-email-editor";
import { AngularToastifyModule, ToastService } from "angular-toastify";
import { DxBarGaugeModule, DxButtonGroupModule, DxButtonModule, DxChartModule, DxCheckBoxModule, DxColorBoxModule, DxContextMenuModule, DxDataGridModule, DxDateBoxModule, DxDrawerModule, DxDropDownBoxModule, DxDropDownButtonModule, DxFileUploaderModule, DxFormModule, DxHtmlEditorModule, DxListModule, DxLoadPanelModule, DxNumberBoxModule, DxPieChartModule, DxPopupModule, DxSchedulerModule, DxSelectBoxModule, DxSortableModule, DxSpeedDialActionModule, DxSwitchModule, DxTabsModule, DxTagBoxModule, DxTextAreaModule, DxTextBoxModule, DxToastModule, DxTooltipModule } from "devextreme-angular";
import { AppComponent } from "./app.component";
import { components, routes } from "./app.routing";

@NgModule({
	bootstrap: [AppComponent],
	declarations: [
		AppComponent,
		...components
	],
	imports: [
		AngularToastifyModule,
		BrowserModule,
		CommonModule,
		EmailEditorModule,
		HttpClientModule,
		FormsModule,
		RouterModule,
		RouterModule.forRoot(routes),
		DxBarGaugeModule,
		DxButtonModule,
		DxButtonGroupModule,
		DxChartModule,
		DxCheckBoxModule,
		DxColorBoxModule,
		DxContextMenuModule,
		DxDataGridModule,
		DxDateBoxModule,
		DxDrawerModule,
		DxDropDownBoxModule,
		DxDropDownButtonModule,
		DxFileUploaderModule,
		DxFormModule,
		DxHtmlEditorModule,
		DxListModule,
		DxLoadPanelModule,
		DxNumberBoxModule,
		DxPieChartModule,
		DxPopupModule,
		DxSchedulerModule,
		DxSelectBoxModule,
		DxSortableModule,
		DxSpeedDialActionModule,
		DxSwitchModule,
		DxTabsModule,
		DxTagBoxModule,
		DxTextBoxModule,
		DxTextAreaModule,
		DxToastModule,
		DxTooltipModule,
		ZXingScannerModule
	],
	providers: [
		AccidentService,
		AllocationService,
		AllocationWorkOrderService,
		AppSettingsService,
		AssetService,
		AssetEventService,
		AssetTypeService,
		AuditService,
		AzureBlobStorageService,
		AuthService,
		BankDetailsService,
		BannerService,
		ClientContactService,
		ClientDocumentService,
		ClientInteractionService,
		ClientLocationService,
		ClientService,
		CrmContactService,
		CrmEventService,
		CrmEventAttendeeService,
		CrmInteractionService,
		CrmLeadService,
		CrmOpportunityService,
		CrmTaskService,
		CompanyHolidayService,
		ContractService,
		ContractPaymentService,
		CriticalSpareService,
		CuttingToolService,
		DashboardService,
		DeliveryNoteService,
		EdiForecastService,
		EdiMessageService,
		EdiOrderService,
		EdiShippingNoteService,
		EdiShippingNoteItemService,
		EmailService,
		EmailTemplateService,
		ExportLogService,
		ExternalPackagingService,
		ExternalPackagingStockMovementHistoryService,
		FeatureService,
		FileService,
		FirewallLogService,
		FirewallLogFailureReasonService,
		GroupService,
		HelpDocumentService,
		HolidayAllowanceService,
		HolidayRequestService,
		HolidaySettingsService,
		InterfaceDeviceService,
		InvoiceService,
		LinkedPartGroupService,
		LoadingService,
		LogService,
		MachineService,
		MachineAvailabilityService,
		MachineEventService,
		MachineQuestionnaireService,
		MachineRequestService,
		MaintenanceScheduleService,
		MaterialService,
		MenuService,
		MenuItemService,
		ModalService,
		NonConformanceReportService,
		OperationService,
		OpsActionAuditService,
		OutsideProcessContractService,
		OutsideProcessContractContingencySupplierService,
		OutsideProcessContractMovementService,
		OutsideProcessTypeService,
		OutsourcedSpecificationService,
		PackagingService,
		PackagingStockMovementHistoryService,
		PartService,
		PartRelationshipService,
		PaymentTermService,
		PFMEAService,
		ProcessService,
		ProcessMachineService,
		ProductionRequestService,
		ProductionToolService,
		ProductionToolEventService,
		ProductionToolBomItemService,
		ProductionToolPartService,
		ProductionToolProgramLineService,
		ProductionToolProgramService,
		ProjectService,
		PromiseService,
		ProtectedGridService,
		PurchasableItemService,
		PurchaseLogService,
		PurchaseLogLineItemAllocationService,
		PurchaseLogWorkOrderService,
		QmsDocumentService,
		QmsDocumentVersionService,
		QuarantinedPartService,
		QuotationAnalysisFormService,
		ReportService,
		RequestForQuoteService,
		SalesEnquiryService,
		SalesOrderService,
		SalesOrderPartService,
		ScheduledReportService,
		SiteService,
		SkillService,
		SmsService,
		SmsTemplateService,
		StaffAttendanceService,
		StockStoreService,
		StockStoreHistoryService,
		StockStoreWorkOrderAllocationService,
		SupervisorRequestReasonService,
		SupervisorRequestService,
		SupplierContactService,
		SupplierService,
		SupplierDocumentService,
		SupplierLocationService,
		SupplierQuestionnaireService,
		SupplierPurchaseTypeService,
		SystemParameterService,
		ToastService,
		ToolHolderService,
		ToolHolderMachineService,
		ToolroomProcessService,
		ToolroomProcessMachineService,
		ToolOrderService,
		ToolingTypeService,
		TrainingService,
		UserService,
		UserLoginCountryBypassService,
		UserProfileService,
		VisitService,
		VisitorService,
		WorkloadLogService,
		WorkOrderService,
		WorkOrderStageService,
		WorkOrderStageInspectionService,
		{
			multi: true,
			provide: HTTP_INTERCEPTORS,
			useClass: HttpClientInterceptor
		}
	]
})
export class AppModule { }